<template>
  <el-dialog
      :visible.sync="visible"
      title="创建预付款"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%"
  >
    <el-form
        ref="dataForm"
        :model="dataForm"
        :rules="dataRule"
        label-width="120px"
    >
      <el-row :gutter="16">
        <el-col :span="6">
          <el-form-item prop="payDate" label="付款时间：">
            <el-date-picker type="date" v-model="dataForm.payDate" size="mini" placeholder="请选择付款时间"
                            value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="receiverId" label="收款方：">
            <company v-model="dataForm.receiverId"  size="mini"></company>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="payAmount" label="付款金额：">
            <el-input v-model="dataForm.payAmount" size="mini" clearable type="text"
                      placeholder="请输入付款银行" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="payBank" label="付款银行：">
            <el-input v-model="dataForm.payBank" size="mini" clearable type="text"
                      placeholder="请输入付款银行"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="6">
          <el-form-item prop="payAccount" label="付款账号：">
            <el-input v-model="dataForm.payAccount" size="mini" clearable type="text"
                      placeholder="请输入付款账号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="receiverBank" label="收款行：">
            <el-input v-model="dataForm.receiverBank" size="mini" clearable type="text"
                      placeholder="请输入收款行"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="receiverAccount" label="收款账号：">
            <el-input v-model="dataForm.receiverAccount" size="mini" clearable type="text"
                      placeholder="请输入收款账号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="receiverName" label="收款人：">
            <el-input v-model="dataForm.receiverName" size="mini" clearable type="text"
                      placeholder="请输入收款人"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
          $t('confirm')
        }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { moneyValidator } from '@/utils/validate'
import BigNumber from 'bignumber.js'

export default {
  name: 'pay-dialog',
  data () {
    return {
      dataForm: {
        payDate: '',
        payNo: '',
        payBank: '',
        payAccount: '',
        receiverBank: '',
        receiverAccount: '',
        receiverName: '',
        payAmount: '',
        type:10,
        receiverId:''
      },
      dataList: [],
      visible: false,
      dataRule: {
        amount: [
          { required: true, message: '请填写金额', trigger: 'change' },
          { validator: moneyValidator, trigger: 'change' },
        ],
        payDate: [
          { required: true, message: '请填写付款时间' }
        ],
        payNo: [
          { required: true, message: '请填写付款凭证号' }
        ],
        payAmount: [
          { required: true, message: '请填写金额', trigger: 'change' },
          { validator: moneyValidator, trigger: 'change' },
        ],
        receiverId: [
          { required: true, message: '请填写金额', trigger: 'change' },
          { validator: moneyValidator, trigger: 'change' },
        ],
      }
    }
  },
  methods: {
    init (detailList) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
      })
    },
    dataFormSubmitHandle () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.doSave()
      })
    },
    cancel () {
      this.visible = false
    },
    async doSave () {
      let postForm =this.$copy(this.dataForm)
      this.$api.post(`/erp/pay/money`, postForm).then(res=>{
        this.$emit('complete')
        this.$c.success('保存成功').then(()=>{
          this.cancel()
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
